import { forwardRef } from 'react';

import Select from './Select';
import type { SelectProps } from './types/SelectProps';

type SelectBoxProps = Omit<SelectProps, 'ref'>;

const SelectBox = forwardRef<HTMLElement, SelectBoxProps>((props, ref) => {
  return <Select ref={ref} {...props} />;
});

SelectBox.displayName = 'SelectBox';

export default SelectBox;
